module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_circle02-115de3e73f95ff083df67b501fb33d80.svg";